const NotificationsEmptyView = () => {
  return (
    <div className="flex size-full flex-1 flex-col items-center justify-center bg-white">
      <div className="flex w-full max-w-[90%] flex-col items-center gap-6">
        <div className="relative h-[95px] w-full max-w-[520px]">
          <div className="absolute inset-x-0 bottom-0 z-[3] h-[65px] rounded-[20px] bg-background shadow-[0_2px_12px_rgba(27,48,41,0.1)]" />
          <div className="absolute inset-x-[11px] bottom-[11px] z-[2] h-[70px] rounded-[15px] bg-[#F2F2F2] shadow-[0_2px_12px_rgba(27,48,41,0.1)]" />
          <div className="absolute inset-x-[22px] bottom-[22px] z-[1] h-[70px] rounded-[15px] bg-[#F2F2F2] shadow-[0_2px_12px_rgba(27,48,41,0.1)]" />
        </div>
        <p className="max-w-[90%] text-center text-base leading-[1.4] text-primary">
          Your notifications will live here!
        </p>
      </div>
    </div>
  )
}

export default NotificationsEmptyView
